<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <div class="mt-5 container mx-auto">
    <div class="flex flex-col gap-2 mt-4 mb-2">
      <div class="text-lg text-center">
        <strong>{{ item.ativo == 'S' ? 'Desativando' : 'Ativando' }}</strong>
        motivo: <strong>{{ item.descricao }}</strong
        >?
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="flex flex-col items-center gap-4">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
</mat-card>
